const PRODUCT_QUANTITY_MODEL_CLASS_NAME = 'ProductQuantity'
const PRODUCT_QUANTITY_MODEL_KEY = {
  ID: 'id',
  PRODUCT_QUANTITY_MODEL_CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  VALUE: 'value',
  NAME: 'name',
  PRODUCT: 'product',
  // Foreign keys
  PRODUCT_ID: 'productId'
}

const PRODUCT_QUANTITY_MODEL_KEY_POINTER = PRODUCT_QUANTITY_MODEL_KEY.ID

export {
  PRODUCT_QUANTITY_MODEL_CLASS_NAME,
  PRODUCT_QUANTITY_MODEL_KEY,
  PRODUCT_QUANTITY_MODEL_KEY_POINTER
}
